import React from "react";

import Link from "next/link";

import { buttonVariants } from "@/components/flowbite/button/button";
import { TableCell } from "@/components/flowbite/table/table-cell";
import { TableHead } from "@/components/flowbite/table/table-head";
import { TableRow } from "@/components/flowbite/table/table-row";
import Typography from "@/components/flowbite/typography/typography";
import { OpenNewWindowIcon } from "@/components/icons-lib";
import { cn } from "@/shared/helpers/cn.helper";

import { BASIC_INFO_ROW_CELL_BORDER_CLASS } from "./basic-information-table-row-border";

interface BasicInformationTableLinkRowProps {
  head: string;
  value: string;
  href: string;
}

export const BasicInformationTableLinkRow: React.FC<
  BasicInformationTableLinkRowProps
> = ({ head, value, href }) => {
  return (
    <TableRow>
      <TableHead
        className={cn(
          "m-0 h-[50px] min-h-[50px] w-[100px] min-w-[100px] max-w-[100px] whitespace-normal text-wrap break-words p-0 pr-3",
          BASIC_INFO_ROW_CELL_BORDER_CLASS,
        )}
      >
        <Typography.TableTitleXS colorShade={300}>
          {head}
        </Typography.TableTitleXS>
      </TableHead>
      <TableCell
        className={cn(
          "m-0 flex h-[50px] min-h-[50px] min-w-0 overflow-hidden p-0",
          BASIC_INFO_ROW_CELL_BORDER_CLASS,
        )}
      >
        <Link
          className={cn(
            buttonVariants({
              variant: "link",
              size: "big",
              typography: "bodyMRegular",
            }),
            "min-w-0 max-w-full gap-2.5 overflow-hidden",
          )}
          href={href}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className="truncate">{value}</span>
          <OpenNewWindowIcon className="h-5 w-5 shrink-0 text-inherit" />
        </Link>
      </TableCell>
    </TableRow>
  );
};
